import { baseURL } from '../Config';
import axios from 'axios';
import { toast } from 'react-toastify';
import { trimData } from '../utilities/TrimPayloadData';
import { loadingAction } from '../redux/actions/loadingAction';
import { showMessageAction } from '../redux/actions/showMessageAction';
import store from '../redux/store';

export const handlePostRequest =
    (data, url, isShowLoad = false, isShowToast = true, nextPageToLoad = '', expectedStatusCode = 200) =>
    async (dispatch) => {
        data = await trimData(data);
        try {
            if (isShowLoad) dispatch(loadingAction(true));

            const response = await axios.post(`${baseURL + url}`, data);

            if (Array.isArray(response?.data)) {
                // Handle array response
                const result = response.data;

                if (isShowToast) {
                    toast.success('Operation successful!', { autoClose: 2000 });
                } else {
                    store.dispatch(
                        showMessageAction({
                            isShowModal: true,
                            message: 'Operation successful!',
                            isError: false,
                            url: nextPageToLoad
                        })
                    );
                }

                if (isShowLoad) dispatch(loadingAction(false));
                return result; // Return the response array
            }

            // If response is not an array, check for statusCode as fallback
            const { statusCode, statusMessage, body } = response?.data || {};

            if (statusMessage === 'Invalid Token' || statusMessage === 'Session Expired') {
                localStorage.clear();
                setTimeout(() => {
                    window.location.href = '/';
                }, 1000);
            }

            if (isShowToast) {
                toast[statusCode === expectedStatusCode ? 'success' : 'warn'](statusMessage || 'Operation failed!', { autoClose: 2000 });
            } else {
                store.dispatch(
                    showMessageAction({
                        isShowModal: true,
                        message: statusMessage || (statusCode === expectedStatusCode ? 'Success' : 'Something Went Wrong'),
                        isError: statusCode !== expectedStatusCode,
                        url: nextPageToLoad
                    })
                );
            }

            if (isShowLoad) dispatch(loadingAction(false));
            return response?.data;
        } catch (error) {
            const errorMessage = error?.response?.data?.statusMessage || error?.response?.data?.message || 'Something went wrong!';

            if (errorMessage === 'Invalid Token' || errorMessage === 'Session Expired') {
                localStorage.clear();
                setTimeout(() => {
                    window.location.href = '/';
                }, 1000);
            }

            if (isShowLoad) dispatch(loadingAction(false));

            if (isShowToast) {
                toast.error(errorMessage, { autoClose: 2000 });
            } else {
                store.dispatch(
                    showMessageAction({
                        isShowModal: true,
                        message: errorMessage,
                        isError: true
                    })
                );
            }

            return error?.response;
        }
    };

